import { EPopupGroupActions } from '~/src/components/ConnectDomruPopup/context/constants/actions';
import { TPopupGroupState } from '~/src/components/ConnectDomruPopup/context/initialState';
import { IAction } from '~/src/store';

export const setView = (view: TPopupGroupState): IAction<EPopupGroupActions.SetView, { view: TPopupGroupState }> => ({
    type: EPopupGroupActions.SetView,
    payload: {
        view,
    },
});
